import type { IconDefaultProps } from './types'

const CloseIcon = ({ className }: IconDefaultProps): JSX.Element => (
  <svg
    className={className}
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path d='M3.5 3.5L20.5 20.5' stroke='currentColor' strokeWidth='2' />
    <path d='M3.5 20.5L20.5 3.5' stroke='currentColor' strokeWidth='2' />
  </svg>
)

export default CloseIcon
